import { MarkSpec } from 'prosemirror-model';
import { Marks } from '../../constants';
import { Extension } from './Extension';

export class BaseMark extends Extension<MarkSpec> {
  constructor(name: Marks) {
    super(name, 'mark');
  }
}
